import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 74027 72212"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#fefefe;stroke-width:1050.78}.fil0{fill:#000}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        id="XMLID_329_"
        d="M66417 14522z"
        className="fill stroke1"
        style={{
          strokeWidth: 1050.78,
        }}
      />
      <path
        id="XMLID_502_"
        d="m38011 34102 24948-18285-18639 6978-6309-19468z"
        className="fill stroke1"
        style={{
          strokeWidth: 1050.78,
        }}
      />
      <path id="XMLID_503_" d="M53297 71802z" className="fill stroke1"
        style={{
          strokeWidth: 1050.78,
        }} />
      <path id="XMLID_504_" d="M37046 351v-2z" className="fill stroke1"
        style={{
          strokeWidth: 1050.78,
        }} />
      <path
        id="XMLID_505_"
        d="m52837 68379-2689-19961 20687-1845-32022-8956z"
        className="fill stroke1"
        style={{
          strokeWidth: 1050.78,
        }}
      />
      <path
        id="XMLID_506_"
        d="M64827 16929 39260 35666l31133 8705-16990-10168z"
        className="fill stroke1"
        style={{
          strokeWidth: 1050.78,
        }}
      />
      <path
        id="XMLID_507_"
        d="M37010 38483 22790 69578l14214-14843 14189 14864z"
        className="fill stroke1"
        style={{
          strokeWidth: 1050.78,
        }}
      />
      <path
        id="XMLID_508_"
        d="M36011 34098V3529l-6273 19255-18630-7008z"
        className="fill stroke1"
        style={{
          strokeWidth: 1050.78,
        }}
      />
      <path id="XMLID_509_" d="M20686 71777z" className="fill stroke1"
        style={{
          strokeWidth: 1050.78,
        }} />
      <path
        id="XMLID_510_"
        d="m21152 68350 14056-30734-32022 8904 20685 1877z"
        className="fill stroke1"
        style={{
          strokeWidth: 1050.78,
        }}
      />
      <path
        id="XMLID_511_"
        d="M20637 34178 3634 44320l31127-8656L9242 16885z"
        className="fill stroke1"
        style={{
          strokeWidth: 1050.78,
        }}
      />
    </g>
  </svg>
);
export default SvgComponent;
